import { merge, toString } from "lodash";
import { useSkillsFrameworks } from "PFCore/hooks/queries/admin/skills_frameworks/use_skills_frameworks";
import { SkillsFramework } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useSkillsFrameworksListColumns } from "../table/use_skills_frameworks_table_columns";
import { useSkillsFrameworksTab } from "./use_skills_frameworks_tab";

export const useSkillsFrameworksListPage = () => {
  const { activeTab, page } = useSkillsFrameworksTab();
  const [params, setParams] = useState<QueryParams>({
    page,
    perPage: 20,
    filters: {
      fields: {
        rank: activeTab
      }
    }
  });
  const [frameworkToDelete, setFrameworkToDelete] = useState<SkillsFramework | null>(null);

  const {
    data: skillsFrameworks,
    isFetching,
    error
  } = useSkillsFrameworks(params, { keepPreviousData: true });
  const { columns } = useSkillsFrameworksListColumns();

  useEffect(() => {
    setParams((previousParams) => ({ ...previousParams, page }));
  }, [page]);

  const setFilters = useCallback(
    (filters: QueryParams["filters"]) => setParams((prevParams) => merge({}, prevParams, { filters })),
    [setParams]
  );

  useEffect(() => {
    setFilters({ fields: { rank: activeTab } });
  }, [setFilters, activeTab]);

  const setOrder = useCallback(
    (order: QueryParams["order"]) => setParams((prevParams) => ({ ...prevParams, order })),
    [setParams]
  );

  const term = useMemo<string>(
    () => toString(skillsFrameworks?.meta.filters?.fields?.term.value) || "",
    [skillsFrameworks?.meta.filters]
  );

  const setTerm = (newTerm: string) => setFilters({ fields: { term: newTerm } });

  return {
    error,
    skillsFrameworks,
    filters: params.filters,
    setFilters,
    setOrder,
    columns,
    frameworkToDelete,
    setFrameworkToDelete,
    isFetching,
    term,
    setTerm
  };
};
